module.exports = __webpack_public_path__ + "ki.fbd04c211183d17a92d4.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/1x1/ki.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/1x1/ki.svg
// module chunks = styles